import type { BorrowMarketRow } from '@/hooks/useBorrowMarkets'
import type { PopoverProps } from '@radix-ui/react-popover'
import { BorrowMarketsRangeFilter, BorrowMarketsRangeFilterAccordion } from './borrowMarketsRangeFilter'

interface BorrowLiquidityFilterProps extends Pick<PopoverProps, 'modal'> {
  borrowMarkets: BorrowMarketRow[]
  className?: string
}

export const BorrowLiquidityFilter = ({ borrowMarkets, className, modal }: BorrowLiquidityFilterProps) => (
  <BorrowMarketsRangeFilter
    borrowMarkets={borrowMarkets}
    type="availableToBorrow"
    className={className}
    modal={modal}
  />
)

export const BorrowLiquidityFilterAccordion = ({
  borrowMarkets,
}: Pick<BorrowLiquidityFilterProps, 'borrowMarkets'>) => (
  <BorrowMarketsRangeFilterAccordion borrowMarkets={borrowMarkets} type="availableToBorrow" />
)
